import axios from "axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

export type CountryRisklevel = {
  id: number;
  country?: { id: number; name: string } | null;
  risk_level?: string;
  updated_at?: string;
};

const fetch = (authHeader: string) => async () => {
  const url = `${env.verifyServiceUrl}individual/country_risk_level/?all=true`;

  const res = await axios.get<CountryRisklevel[]>(url, {
    headers: { Authorization: authHeader },
  });

  return res.data;
};

export const useGetCountryRiskLevel = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery<CountryRisklevel[], Error>(
    ["country_risk_level"],
    fetch(authHeader),
    {
      retry: false,
      onError: (err: any) => {
        const status = err?.response?.status ?? err?.request?.status;
        if (status === 500 || status === 503) navigate(ROUTE.SERVER_ERROR);
        if (status === 401) navigate(ROUTE.LOGOUT);
      },
    }
  );
};
